import React from "react";
import Image from "next/image";
import Link from "next/link";
// import { BASE_ASSETS_URL } from "../../../constants/constants";

const BlogCard2 = ({
  blogImage,
  // image,
  // imageWidth = "w-full md:h-[250px] lg:h-[367px] xl:h-[370px]",
  title,
  genre,
  date,
  blogUrl,
  // genreColor,
  customTitle,
  // imageBorders,
  // localAsset = false,
  meta_description,
}) => {
  return (
    <Link
      href={blogUrl}
      target="_blank"
      className={`w-full flex flex-col  rounded-3xl overflow-hidden bg-white hover:bg-surface  transition-all duration-500 ease-in-out border border-surface-dark`}
    >
      <div className="w-full flex items-center justify-center mx-auto h-[280px]">
        <Image
          src={`${blogImage}`}
          alt={title}
          width={100}
          height={100}
          className="w-full h-full object-cover "
        />
      </div>
      <div className=" md:px-8 px-6 py-8 w-full ">
        <div className="flex justify-between items-centser gap-4  mb-5">
          <p className={` text-base font-semibold text-gray-600`}>{genre}</p>
          <p>{date}</p>
        </div>
        <div
          className={`text-xl lg:text-[20px] leading-[26px] font-semibold ${
            customTitle ? customTitle : ""
          }`}
        >
          {title}
        </div>
        <div className="text-base text-gray-700 mt-3 ">{meta_description}</div>
      </div>
    </Link>
  );
};

export default BlogCard2;
